var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { Controller, } from "react-hook-form";
export const FSwitch = (_a) => {
    var { name, control, label, error } = _a, props = __rest(_a, ["name", "control", "label", "error"]);
    return (React.createElement(Controller, { name: name, control: control, render: ({ field }) => (React.createElement(FormControlLabel, { control: React.createElement(Switch, Object.assign({}, field, { checked: !!field.value, onChange: (e) => field.onChange(e.target.checked) }, props)), label: label })) }));
};
